import {
  sharedList,
  sharedSizes,
  sharedTitle,
} from '../../assets/shared.styles';

export const styles = {
  container: {
    pt: '1.5rem',
    display: 'flex',
    justifyContent: 'center',
  },
  mainBox: sharedList.mainBox,
  mainTitleBox: sharedList.mainTitleBox,
  mainTitle: sharedTitle.categoryTitle,
  mainSubTitle: sharedTitle.categorySubTitle,
  tableRow: {
    cursor: 'pointer',
  },
  thingImage: (img: string | ArrayBuffer | null) => {
    return {
      width: '3.7rem',
      height: '3.1rem',
      backgroundImage: `url(${img})`,
      backgroundSize: 'cover',
      borderRadius: sharedSizes.borderRadiusImgTiny,
    };
  },
  tableHead: sharedList.tableHead,
  tableBody: sharedList.tableBody,
  tableContainer: sharedList.tableContainer,
  paginationBox: sharedList.paginationBox,
};
